import { Fragment, useContext } from "react";
import type { FunctionComponent } from "react";
import { AlertType } from "@ppb/the-wall-common/types";
import { Alert } from "@ppb/the-wall-web";
import { SelectionsBoard, SelectionsBoardSection } from "../SelectionsBoard/SelectionsBoard.web";
import { SelectionsBoardTheme } from "../SelectionsBoard/SelectionsBoard.types";

import ConnectedBetControls from "../BetControls";
import { BetControls } from "../BetControls/BetControls.web";
import { ConnectedSelectionMultiBetBuilder } from "../Selection";
import { Selection } from "../Selection/Selection.web";
import { RootBetslipContext } from "../RootBetslip/RootBetslipContext";
import { SelectionHint } from "../SelectionHint/SelectionHint.web";

import { ComponentProps } from "./props";
import styles from "./MultiBetBuilderCard.web.css";
import { SelectionConnector } from "../SelectionConnector/SelectionConnector.web";
import { getConnectorVariant } from "../../helpers/get-connector-variant";

export const MultiBetBuilderCard: FunctionComponent<ComponentProps> = ({
  id,
  title,
  groups,
  i18n,
  isNotificationVisible,
  shouldFocusStakeField,
  hasSelectionConnector,
  dispatchBetslipBetBuilderMultisDismissNotification,
}) => {
  const { isBetConfirmationStep } = useContext(RootBetslipContext);

  if (!id) {
    return null;
  }

  return (
    <div className={styles.multiBetBuilderCard}>
      {isNotificationVisible && (
        <div className={styles.notificationsListContainer}>
          <Alert
            type={AlertType.Info}
            message={i18n.notification}
            onClose={dispatchBetslipBetBuilderMultisDismissNotification}
            showCloseIcon={true}
          />
        </div>
      )}
      <SelectionsBoard theme={SelectionsBoardTheme.Blue} hasHeader={false}>
        {Object.values(groups).map(({ legIds, legHints, title: eventTitle, urn }) => (
          <SelectionsBoardSection key={urn} title={eventTitle}>
            {(legHints ?? [{ legIds }]).map((group) => {
              const shouldShowSelectionConnector = hasSelectionConnector && group.legIds.length > 1;
              const selections = group.legIds.map((legId, index) => (
                <div key={legId} className={styles.legRow}>
                  {shouldShowSelectionConnector && (
                    <SelectionConnector variant={getConnectorVariant(index, group.legIds.length)} />
                  )}
                  <div className={styles.legContent}>
                    <ConnectedSelectionMultiBetBuilder
                      component={Selection}
                      id={legId}
                      isReadOnly={isBetConfirmationStep}
                    />
                  </div>
                </div>
              ));

              return group.hintMessage ? (
                <SelectionHint key={group.legIds[0]} hintMessage={group.hintMessage}>
                  {selections}
                </SelectionHint>
              ) : (
                <Fragment key={group.legIds[0]}>{selections}</Fragment>
              );
            })}
          </SelectionsBoardSection>
        ))}
      </SelectionsBoard>
      <h3 className={styles.betType}>{title}</h3>
      <ConnectedBetControls component={BetControls} combinationId={id} shouldFocusStakeField={shouldFocusStakeField} />
    </div>
  );
};
